export enum EventTypes {
  event='EVENT',
  alarm='ALARM'
}
